const Stats = (props) => {
    return (
        <>STATS</>
    )
};
export default Stats;